import { Fragment, FunctionalComponent, h } from '@stencil/core';
import { CountdownComponent } from './CountdownComponent';
import { CountdownDivider } from './CountdownDivider';
import { Countdown } from './CountdownService';

type Props = { countdown: Countdown; }

export const CountdownClock: FunctionalComponent<Props> = ({ countdown }) => {
  const { days, hours, minutes, seconds } = countdown;
  return (
    <div class="row align--center">
      {Boolean(days) && (
        <Fragment>
          <CountdownComponent value={days}>days</CountdownComponent>
          <CountdownDivider />
        </Fragment>
      )}

      {Boolean(days || hours) && (
        <Fragment>
          <CountdownComponent value={hours}>hours</CountdownComponent>
          <CountdownDivider />
        </Fragment>
      )}

      {Boolean(hours || minutes) && (
        <Fragment>
          <CountdownComponent value={minutes}>minutes</CountdownComponent>
          <CountdownDivider />
        </Fragment>
      )}

      <CountdownComponent value={seconds}>seconds</CountdownComponent>
    </div>
  );
}
